import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { removeSurroundingQuotes } from '../../helpers';
export const sortNavigationStmtInstruction = `
#### Sort navigation items

- Syntax: \`sort navigation: "<label1>", "<label2>", "<label3>", ...;\`
- Example: \`sort navigation "Products", "Users", "Articles";\`

#### Sort child navigation items
Sort child items under a parent navigation item.

- Syntax: \`sort navigation "<parentLabel>": "<label1>", "<label2>", "<label3>", ...;\`
- Example: \`sort navigation "Catalog": "Products", "Tags", "Create new";\`
`;
export const stmtSortNavigation = ({ labels, label }) => {
    return `sort navigation${label ? ` ${label}:` : ':'} ${labels.map(it => `"${it}"`).join(', ')};`;
};
export const sortNavigationHandler = createStructureStatementHandler({
    type: 'sort navigation',
    parse: line => {
        const match = /^sort navigation(\s)?(?<label>["]\w.+"(?:\w.+")*)?: (?<labels>["]\w.+"(?:->"\w.+")*)/.exec(line);
        return match?.groups
            ? {
                type: 'sort navigation',
                labels: match.groups.labels.split(',').map(it => removeSurroundingQuotes(it.trim())),
                label: match.groups.label ? removeSurroundingQuotes(match.groups.label) : undefined,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.sortNavigationItems({
                labels: stmt.labels,
                label: stmt.label,
            });
        });
    },
});
//# sourceMappingURL=SortNavigationStmt.js.map